import React from "react";
import { NoDataImage } from "../../assets/Icons";

const NoDataFound = ({ text, spacing }) => {
  return (
    <>
      <div className={`text-center ${spacing ? spacing : " py-4"}`}>
        <NoDataImage/>
        <h5 className="mt-4">{text}</h5>
      </div>
    </>
  );
};

export default NoDataFound;
